import { useEffect } from 'react';
import useAuthStore from '../store/useAuthStore';
import useShopStore from '../store/useShopStore';

/* ===========================================================================
 *  Puente con el constructor de anuncios de ConsolTech.
 *
 *  No pinta nada: el widget se dibuja solo, aislado en su propio Shadow DOM,
 *  y no puede chocar con los estilos de esta aplicación.
 *
 *  POR QUÉ ES UN EFECTO Y NO UNA LLAMADA DENTRO DEL LOGIN
 *  useAuthStore persiste en localStorage. Al recargar la página el usuario se
 *  restaura sin pasar por `setCredentials`, así que enganchar la
 *  identificación al login la perdería en cada F5. Observando el estado
 *  funciona siempre: al entrar, al recargar y al cambiar de taller.
 *
 *  TODAS las llamadas van con `?.`: si el widget no cargó —red caída, un
 *  bloqueador, el servicio de anuncios apagado— esta aplicación no debe
 *  romperse. Un anuncio nunca puede tumbar el taller.
 * =========================================================================== */
export default function AnunciosConsolTech() {
  const user = useAuthStore((s) => s.user);
  const selectedShop = useShopStore((s) => s.selectedShop);

  // El superadmin no pertenece a un taller: trabaja sobre el que tenga elegido.
  // Los demás pertenecen al suyo y no lo cambian.
  const shop = selectedShop || user?.shop;
  const shopId = shop?._id || shop?.id || (typeof shop === 'string' ? shop : '');

  useEffect(() => {
    if (!user) {
      window.CTAnnounce?.reset();
      return;
    }
    window.CTAnnounce?.identify({
      tenantId: String(shopId || ''),
      tenantName: shop?.name || '',
      userId: String(user._id || user.id || ''),
      // Nombre y correo por separado: en el panel de anuncios el nombre es lo
      // que se lee en las tablas y el correo lo que identifica sin ambigüedad
      // cuando hay dos personas que se llaman igual.
      userLabel: user.name || user.email || '',
      userEmail: user.email || '',
      role: user.role || '',
    });
  }, [user, shopId, shop?.name]);

  return null;
}
